// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2IWuC","label":"Completed_label__34Yp8"};